module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_m_albino.6f48b4a8.png";